<template>
    <div class="relative">
        <theme-calendar 
          ref="picker" 
          :label="label" 
          :name="name" 
          :value="date" 
          @input="inputHandler">
        </theme-calendar>

        <div class="absolute top-[52%] right-4 z-10" v-if="this.date">
            <span @click="prev"><i class="icon-thin-left orange-icon py-2 px-3"></i></span>
            <span @click="next"><i class="icon-thin-right orange-icon py-2 px-3"></i></span>
        </div>
    </div>

</template>

<script>
    import field from '../admin/mixins/field';
    import 'moment';

    export default {
      mixins: [field],
      components: {
      },
      data() {
        return {
          date: this.value,
        }
      },
      methods: {
        next() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).add(1, 'd').format('DD-MM-YYYY');
            this.$emit('next', this.date);
          }
        },
        prev() {
          if (this.date) {
            let datetime = this.date.split(' ');
            let date = datetime[0].split('-');
            let prevDate = new Date(date[2], parseInt(date[1]) - 1, date[0]).getTime();
            this.date = moment(prevDate).subtract(1, 'd').format('DD-MM-YYYY');
            this.$emit('prev', this.date);
          }
        },
        inputHandler(value) {
          this.date = value;
          this.$emit('phrase', value);
        }
      },
      watch: {
        value(newValue) {
          this.date = newValue;
        }
      }
    }
</script>